import Marquee from "react-fast-marquee";
import { createFileRoute } from "@tanstack/react-router";

import { Divider, Heading } from "@/ui";
import {
  SourceOfKnowledgeCard,
  sourcesOfKnowledge,
  TeamMemberProfileCard,
  teamMembers,
  TrustedByLogos,
} from "./-components";

const ClinicalTeam = () => {
  return (
    <>
      <section className="flex flex-col items-center bg-canvas px-5 py-8 text-content sm:px-6 sm:py-20">
        <section className="flex w-full max-w-4xl flex-col gap-9 sm:gap-20">
          <section className="flex flex-col gap-20">
            <div className="flex flex-col gap-6">
              <Heading level={1}>Clinical Team</Heading>

              <Divider.Line />

              <p className="text-content-secondary sm:text-xl">
                {`
                  EO's clinical team includes leading physicians, pharmacists,
                  nurse practitioners and social workers with deep experience in
                  cannabinoid-based care.
                `}
              </p>

              <p className="text-content-secondary sm:text-xl">
                Our team is led by Dr. Brooke Worster, Director of Supportive Oncology at the Sidney
                Kimmel Cancer Center; Dr. Ben Caplan, a leading cannabinoid clinician and educator;
                and Dr. Emily Hajjar, a geriatric pharmacist and professor. Together, they guide our
                clinical approach, product formulations, and personalized care plans.
              </p>
            </div>

            <div className="flex flex-col gap-20">
              {teamMembers.map((member) => {
                return <TeamMemberProfileCard key={member.id} member={member} />;
              })}
            </div>
          </section>

          <section className="flex flex-col gap-8">
            <Heading level={1}>Sources of Knowledge</Heading>

            <Divider.Line />

            <p className="leading-6 text-content-secondary sm:text-xl">
              {`
                EO's guidance is built on three interconnected pillars: Deep
                clinical experience, the latest relevant research, and real-world
                patient data. Together, these pillars help us develop
                purpose-designed products and clear, practical guidance that is
                safe, personalized and easy to follow.
              `}
            </p>

            <div className="flex flex-col gap-10">
              {sourcesOfKnowledge.map((source) => {
                return (
                  <SourceOfKnowledgeCard
                    content={source.content}
                    key={source.id}
                    title={source.title}
                  />
                );
              })}
            </div>
          </section>
        </section>
      </section>

      <section className="flex flex-col items-center gap-10 bg-surface py-16 sm:py-24 sm:text-center">
        <div className="flex max-w-4xl flex-col gap-4 px-4">
          <Heading level={2}>Trusted by Clinicians & Advocates</Heading>

          <p className="text-content-secondary sm:text-xl">
            EO is recommended by clinicians at leading healthcare centers, including Mayo Clinic, Mt
            Sinai Hospital, Northwell Health, Penn Medicine and UVA Health - as well as by leading
            older adult and cancer advocacy organizations.
          </p>
        </div>

        <TrustedByLogos
          containerClasses="hidden items-center justify-center gap-4 lg:flex"
          imageClasses="h-14"
        />

        <Marquee className="flex items-center gap-4 lg:hidden" autoFill>
          <TrustedByLogos
            containerClasses="flex lg:hidden items-center gap-4"
            imageClasses="h-24"
          />
        </Marquee>
      </section>
    </>
  );
};

export const Route = createFileRoute("/_private/(with-footer)/clinical-team/")({
  component: ClinicalTeam,
});
